module.exports = __webpack_public_path__ + "img/ResearchHUB Guiding Principles 11 06 2024-6.8d0b5d0f.png";